// Purchase-stage Meta + Reddit conversion. Assumes `fbq` and `rdt` were
// already initialized by the site-wide `meta-pixel.js` and
// `reddit-pixel.js` (which fire on every marketing route + on
// /post-purchase). Both events fire only when the route loader has
// resolved a positive `amountUsd` (see cookie-trackers-purchase.tsx);
// callers without a real charge skip rendering this script entirely.
//
// Both events use the Meta/Reddit `Purchase` standard event. We
// previously fired `fbq('track', 'StartTrial', { value: 0 })` here —
// that was wrong because the script body only runs for users who
// completed a real charge, so the event name was misclassifying
// purchases as trial signups. Trial signups now flow through
// `meta-pixel-start-trial.ts` instead, gated on the loader's
// `trialStarted` signal (sourced server-side from
// `subscription.status === 'trialing'`).
//
// `currency` is the code Stripe billed in, threaded down from the route
// loader — not a constant. Both platforms take an uppercase ISO 4217
// code, which `normalizeCurrency()` guarantees.
export function metaPixelTrackOrderScript(
  value: number,
  currency: string,
): string {
  return `
/* eslint-disable -- inline pixel script, vendor-shaped js */
fbq('track', 'Purchase', { value: ${value}, currency: '${currency}' });
rdt('track', 'Purchase', { value: ${value}, currency: '${currency}' });
`;
}
